import { h, render } from 'preact';
import { Banner } from './banner';
import { initCookieEnforcer, manageCookies, teardownCookieEnforcer } from './cookies';
import { logConsentToApi } from './api';
import { ConsentStore } from './consent-store';
import { detectLanguage } from './lang';
import { CATEGORIES } from './categories';

const _currentScript = document.currentScript as HTMLScriptElement | null;

initCookieEnforcer();

let apiUrl = '';

function showBanner() {
  if (document.getElementById('galletas4all-widget-container')) return;

  const container = document.createElement('div');
  container.id = 'galletas4all-widget-container';
  document.body.appendChild(container);

  const handleConsent = (accepted: boolean, categories: string[]) => {
    const consentData = {
      accepted,
      categories,
      timestamp: new Date().toISOString()
    };

    ConsentStore.save(consentData);
    manageCookies(consentData);

    if (apiUrl) {
      const acceptedCategories = categories;
      const rejectedCategories = CATEGORIES.filter(c => !categories.includes(c));
      logConsentToApi(apiUrl, { accepted, acceptedCategories, rejectedCategories });
    }

    container.remove();
  };

  const scriptTag = _currentScript || document.querySelector('script[data-api-url]') as HTMLScriptElement | null;
  const detectedLang = detectLanguage(scriptTag);

  render(<Banner onConsent={handleConsent} lang={detectedLang} />, container);
}

if (typeof window !== 'undefined') {
  (window as any).showGalletas4allBanner = showBanner;
  (window as any).onGalletas4allConsentChange = ConsentStore.onChange;
  (window as any).teardownGalletas4all = teardownCookieEnforcer;
}

function init() {
  const scriptTag = _currentScript || document.querySelector('script[data-api-url]') as HTMLScriptElement | null;

  apiUrl = scriptTag?.getAttribute('data-api-url') || '';

  if (!apiUrl) {
    console.info('[Galletas4all] No data-api-url configured — running in local-only mode (no audit logging).');
  }

  const saved = ConsentStore.load();
  if (saved) {
    manageCookies(saved);
    return;
  }

  showBanner();
}

if (typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}
